// @flow

import React, { useRef } from "react";
import { Container, Checkbox as StyledCheckbox, Label } from "./styles";
import Icon from "src/icons";

type Props = {
  checked: boolean,
  onChange: Function,
  label?: string,
  isDisabled?: boolean,
  isMandatory?: boolean,
  height?: string,
  indeterminate?: boolean,
  labelFullWidth?: boolean,
  alignment?: "top" | "center",
};

const getIconString = (checked: boolean): string =>
  checked ? "activePicklistCheckbox" : "defaultPicklistCheckbox";

const Checkbox = ({
  checked,
  label,
  onChange,
  isDisabled = false,
  isMandatory = false,
  height = "24px",
  labelFullWidth = false,
  alignment = "center",
}: Props) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  const handleChange = () => {
    if (isDisabled) return;
    onChange(!checked);
  };

  return (
    <Container
      onClick={handleChange}
      disabled={isDisabled}
      height={height}
      alignment={alignment}
      mandatory={isMandatory}
    >
      <StyledCheckbox checked={checked} onChange={() => {}} ref={checkboxRef} />
      <Icon type={getIconString(checked)} isDisabled={isDisabled} />
      {label && <Label labelFullWidth={labelFullWidth}>{label}</Label>}
    </Container>
  );
};

export default Checkbox;
